import { defineMessages } from 'react-intl'

const messages = defineMessages({
  payNow: {
    id: 'global.pay-now',
  },
  enterCard: {
    id: 'global.select-card',
  },
  cancellationPoliciesRemain: {
    id: 'global.cancel-remain',
  },
  cancelRemainExplain: {
    id: 'global.cancel-remain-explain',
  },
  pendingToPay: {
    id: 'global.pending-pay',
  },
  changeCreditCard: {
    id: 'global.change-credit-card',
  },
  partialPay: {
    id: 'reservation.partial-pay',
  },
  partialTitle: {
    id: 'reservation.partial-pay-title',
  },
  partialPlaceholder: {
    id: 'reservation.partial-pay-placeholder',
  },
})

export default messages
